import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg, TOKEN_KEY } from "@/lib/api";
import { t } from "@/lib/i18n";

export default function ChangePassword() {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 6) return setError(t("Password must be at least 6 characters."));
    if (f.next !== f.confirm) return setError(t("Passwords do not match."));
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      localStorage.setItem(TOKEN_KEY, data.token);
      toast.success(t("Password updated"));
      setF({ current: "", next: "", confirm: "" });
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  const field = (k, label, testId) => (
    <div>
      <label className="hf-label">{label}</label>
      <input type="password" required value={f[k]} onChange={set(k)} className="hf-input" data-testid={testId} autoComplete={k === "current" ? "current-password" : "new-password"} />
    </div>
  );

  return (
    <form onSubmit={submit} className="hf-card p-6 mt-6 space-y-4 max-w-xl" data-testid="change-password-form">
      <p className="flex items-center gap-2 font-display font-bold"><KeyRound className="w-4 h-4 text-amber-600" /> {t("Change password")}</p>
      {field("current", t("Current password"), "current-password-input")}
      <div className="grid sm:grid-cols-2 gap-4">
        {field("next", t("New password"), "new-password-input")}
        {field("confirm", t("Confirm password"), "confirm-password-input")}
      </div>
      {error && <p className="text-sm text-red-600" data-testid="change-password-error">{error}</p>}
      <button disabled={busy} className="hf-btn-dark" data-testid="change-password-submit-btn">{busy ? t("Saving…") : t("Update password")}</button>
    </form>
  );
}
